import React, { useState, useEffect } from 'react';
import FormGroup from '@mui/material/FormGroup';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import FormHelpText from './form-helpText';

interface FormTextAreaItem {
  title?: string;
  required?: boolean;
  validation?: string;
  validationMessage?: string;
  helpText?: string;
}

interface FormTextAreaProps {
  item: FormTextAreaItem;
  unique: string;
  submitted: boolean;
}

const FormTextArea = ({ item, unique, submitted }: FormTextAreaProps) => {
  const [value, setValue] = useState('');
  const [error, setError] = useState(false);
  const validate = (val: string) => {
    if (item.required && val === '') {
      setError(true);
    } else if (item.validation) {
      const regex = new RegExp(item.validation);
      if (!regex.test(val)) {
        setError(true);
      }
    } else {
      setError(false);
    }
  };

  useEffect(() => {
    if (submitted) {
      validate(value);
    }
  }, [submitted, value]);

  return (
    <>
      <FormGroup className="py-4">
        <InputLabel className="font-normal text-[#42474a] tra-text-web-body-m">{`${
          item.title
        }${item.required ? ' *' : ''}`}</InputLabel>
        <TextField
          id={`form-${unique}`}
          name={unique}
          title={unique}
          value={value}
          variant="outlined"
          fullWidth
          multiline
          rows={3}
          required={item.required}
          onBlur={(e) => validate(e.target.value)}
          onChange={(e) => setValue(e.target.value)}
          inputProps={{
            title: `${item.title}${item.required ? ' *' : ''}`,
          }}
          aria-describedby={`${unique}-help`}
          aria-labelledby={`${unique}-help`}
          error={error}
          helperText={error ? item.validationMessage : ''}
          FormHelperTextProps={{
            className: 'mt-1',
          }}
          InputProps={{
            style: {
              backgroundColor: '#ffffff',
              boxShadow: error ? `0px 0px 0px 3px rgba(209, 26, 10, 0.4)` : '',
            } as React.CSSProperties,
            endAdornment: (
              <InputAdornment position="end">
                {error ? (
                  <CancelIcon color="error" />
                ) : value === '' ? (
                  ''
                ) : (
                  <CheckCircleIcon color="primary" />
                )}
              </InputAdornment>
            ),
          }}
        />{' '}
        <FormHelpText
          display={!!item.helpText}
          unique={unique}
          content={item.helpText !== undefined ? item.helpText : ''}
        />
      </FormGroup>
    </>
  );
};

export default FormTextArea;
